import { render, staticRenderFns } from "./DemoProcess.vue?vue&type=template&id=e2306666&scoped=true"
import script from "./DemoProcess.vue?vue&type=script&lang=js"
export * from "./DemoProcess.vue?vue&type=script&lang=js"
import style0 from "./DemoProcess.vue?vue&type=style&index=0&id=e2306666&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2306666",
  null
  
)

export default component.exports